import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchAgroExporterProcesses(producer_id) {
    return RequesterV1.get(
      `producer/production/delivery_container/list_processes/${producer_id}/fetch_agro_exporter_processes`
    );
  }
};
